import { render, staticRenderFns } from "./SidebarOld.vue?vue&type=template&id=0d2a1183&scoped=true"
import script from "./SidebarOld.vue?vue&type=script&lang=js"
export * from "./SidebarOld.vue?vue&type=script&lang=js"
import style0 from "./SidebarOld.vue?vue&type=style&index=0&id=0d2a1183&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2a1183",
  null
  
)

export default component.exports